/* @flow weak */
import _ from 'lodash';
import GlobalAttributes from 'constants/GlobalAttributes';
import SupportedEventNames from 'constants/SupportedEventNames';

const INPUT_ATTRIBUTES = [
  'name',
  'type',
  'accept',
  'autoComplete',
  'autoFocus',
  'checked',
  'defaultChecked',
  'disabled',
  'maxLength',
  'minLength',
  'pattern',
  'placeholder',
  'readOnly',
  'required',
  'size',
  'spellCheck',
  'step',
  'value',
];

const ALLOWED_PROPS = _.union(GlobalAttributes, SupportedEventNames, INPUT_ATTRIBUTES);

export default (props) => {
  return _.pick(props, ALLOWED_PROPS);
};



// WEBPACK FOOTER //
// ./src/utils/pickInputElementProps.js